import React, { FC, ReactNode, useEffect, useRef } from 'react';
import { useAuth } from 'react-oidc-context';

const RECOVERY_KEY = 'oidc_recovery_attempted';

export interface AuthenticationStateHandlerProps {
    authenticated?: ReactNode;
    unAuthenticated?: ReactNode;
    authenticationExpired?: ReactNode;
    loading?: ReactNode;
}

export const AuthenticationStateHandler: FC<AuthenticationStateHandlerProps> = (props) => {

    const auth = useAuth();
    const isRedirecting = useRef(false);

    useEffect(() => {
        return auth.events.addSilentRenewError(() => {
            if (isRedirecting.current) return;
            if (sessionStorage.getItem(RECOVERY_KEY)) return;
            isRedirecting.current = true;
            sessionStorage.setItem(RECOVERY_KEY, '1');
            auth.signinRedirect();
        });
    }, [auth.events, auth.signinRedirect]);

    useEffect(() => {
        if (auth.error && !isRedirecting.current) {
            if (sessionStorage.getItem(RECOVERY_KEY)) return;
            isRedirecting.current = true;
            sessionStorage.setItem(RECOVERY_KEY, '1');
            auth.signinRedirect();
        }
    }, [auth.error, auth.signinRedirect]);

    useEffect(() => {
        if (auth.isAuthenticated) {
            sessionStorage.removeItem(RECOVERY_KEY);
        }
    }, [auth.isAuthenticated]);

    switch (auth.activeNavigator) {
        case "signinSilent":
            return <div>Signing you in...</div>;
        case "signoutRedirect":
            return <div>{props.authenticationExpired!}</div>
        default:
            if (auth.activeNavigator !== undefined) {
                console.log('QQQ auth.activeNavigator: ', auth.activeNavigator);
            }
    }

    if (auth.isLoading) {
        return <div>{props.loading}</div>
    }

    if (auth.error) {
        return <div>{props.loading}</div>;
    }

    return (<div>{auth.isAuthenticated ? props.authenticated : props.unAuthenticated}</div>)

};
export default AuthenticationStateHandler;
